module.exports = __webpack_public_path__ + "img/MUNI-PH.14e06835.png";